<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ header }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :custom-filter="customSearch"
                :no-data-text="noDataText"
                :options.sync="pagination"
                item-key="key"
                show-select
                v-bind:search="search"
                v-model="selected"
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'insured')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'insured')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { interGrpList } from './index'
export default {
  props: {
    apiURI: String,
    mode: String,
    param: String
  },
  data() {
    return {
      headers: [
        { text: 'Inter Group', value: 'id' },
        { text: 'Description', value: 'desc' }
      ],
      header: '',
      selected: [],
      parameter: [],
      items: [],
      paramItems: [],
      interGrpList: [],
      pagination: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
      this.getLabel()
    },
    param: function (value) {
      this.doInit()
      this.getLabel()
    }
  },
  created() {
    this.interGrpList = interGrpList
    this.doInit()
    this.getLabel()
  },
  methods: {
    doInit() {
      this.parameter = this.param.split(',')
      if (this.parameter !== this.checkedItems) {
        this.doReset()
        this.checkedItems = this.parameter
      }
      this.loading = true
      this.items = []
      this.selectedItems = []
      this.interGrpList.map((param) => {
        const convertList = {
          key: param.value,
          id: param.value,
          desc: param.label
        }
        if (this.checkedItems.includes(param.value)) {
          const paramList = {
            key: param.value,
            id: param.value,
            desc: param.label
          }
          this.selectedItems.push(paramList)
        }
        this.items.push(convertList)
      })
      if (this.checkedItems.toString() === 'All') {
        this.doReset()
        this.toggleAll()
      } else {
        this.toggleSelected()
      }
      this.loading = false
    },
    getLabel() {
      this.headers = []
      switch (this.mode) {
        case 'interGrp':
          this.headers.push({ text: 'Inter Group', value: 'id' })
          this.header = 'Intermediary Group'
          break
      }
      this.headers.push({ text: 'Description', value: 'desc' })
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>

<style>
</style>
